import script from "./CorporateRecruit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CorporateRecruit.vue?vue&type=script&setup=true&lang=ts"

import "./CorporateRecruit.vue?vue&type=style&index=0&id=33523986&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33523986"]])

export default __exports__